import { useEffect, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import { MessageBubble } from "@/components/MessageBubble";
import { TypingIndicator } from "@/components/TypingIndicator";
import { EmptyState, ErrorState, RateLimitState } from "@/components/StateCards";

export const ChatContainer = ({ messages, status, errorMsg }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    // Scroll only inside the chat container (never the whole page).
    if (messages.length === 0 && status === "idle") return;
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, status]);

  const isEmpty = messages.length === 0;

  return (
    <div
      ref={scrollRef}
      data-testid="chat-container"
      className="nesan-scroll flex-1 overflow-y-auto min-h-[45vh] max-h-[55vh] px-4 sm:px-6 py-6 space-y-4"
    >
      {isEmpty && status !== "rate_limit" && status !== "error" && (
        <div className="h-full flex items-center justify-center">
          <EmptyState />
        </div>
      )}

      <AnimatePresence initial={false}>
        {messages.map((m) => (
          <MessageBubble key={m.id} role={m.role} content={m.content} />
        ))}
      </AnimatePresence>

      {status === "loading" && <TypingIndicator />}

      {status === "error" && (
        <div className="pt-2">
          <ErrorState message={errorMsg} />
        </div>
      )}

      {status === "rate_limit" && (
        <div className="pt-2">
          <RateLimitState message={errorMsg} />
        </div>
      )}
    </div>
  );
};
